import Pendo from "../Pendo";
import ScrollToTop from "../ScrollToTop";
import AppRouter from "./AppRouter";

const AppRouterWithBrowserRouter = (): JSX.Element => {
  return (
    <>
      <Pendo />
      <ScrollToTop />
      <AppRouter />
    </>
  );
};

export default AppRouterWithBrowserRouter;
